import {
  apply_Promocode_URL,
  get_Payment_Info,
  paymentRequest_URL,
  POST_METHOD,
  promocodeRequest_URL,
} from '../../Apis/api';

export const paymentRequest_API = paymentBody => {
  /* user authentication process */
  //   alert(JSON.stringify(paymentBody));
  return fetch(paymentRequest_URL, {
    method: POST_METHOD,
    body: JSON.stringify(paymentBody),
  }).then(response => {
    return response.json();
  });
};

export const promocodeRequest_API = requestBody => {
  /* user authentication process */
  return fetch(promocodeRequest_URL, {
    method: POST_METHOD,
    body: JSON.stringify(requestBody),
  }).then(response => {
    return response.json();
  });
};

export const applyPromocode_API = requestBody => {
  /* user authentication process */
  return fetch(apply_Promocode_URL, {
    method: POST_METHOD,
    body: JSON.stringify(requestBody),
  }).then(response => {
    return response.json();
  });
};

export const getPaymentInfo_API = requestPayAmount => {
  /* user authentication process */
  return fetch(get_Payment_Info, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestPayAmount),
  }).then((response) => response.json());

};

export const verifyPromocode_API = promoCodeBody => {
  /* user authentication process */
  return fetch(apply_Promocode_URL, {
    method: POST_METHOD,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(promoCodeBody),
  }).then(response => {
    return response.json();
  });
};
